import { getBasicUrls } from "@/util/config";
class LoginUserHelper {
  constructor() {
    this.userHelper = null;
    this.userInfo = null;
    this.sourceInfo = null;
    this.keyUrlLoginToken = "ssoToken";
    this.keyUserInfo = "agent_user_info";
    this.keySourceInfo = "agent_source_info";
    this.keyToken = "token";
  }
  //单例
  static getInstance() {
    if (this.userHelper == null) {
      this.userHelper = new LoginUserHelper();
    }
    return this.userHelper;
  }
  //获取登录用户信息
  getUserInfo() {
    return JSON.parse(localStorage.getItem(this.keyUserInfo) || "{}");
  }
  //获取登录用户来源信息
  getSourceInfo() {
    if (!this.sourceInfo) {
      this.sourceInfo = JSON.parse(
        localStorage.getItem(this.keySourceInfo) || "{}"
      );
    }
    return this.sourceInfo;
    // return localStorage.getItem(this.keySourceInfo);
  }
  //存储登录信息
  saveUserInfo(userInfo) {
    this.userInfo = userInfo || "";
    localStorage.setItem(this.keyUserInfo, JSON.stringify(userInfo));
  }
  //存储登录来源信息
  saveSourceInfo(sourceInfo) {
    this.sourceInfo = sourceInfo || "";
    localStorage.setItem(this.keySourceInfo, JSON.stringify(sourceInfo));
  }
  //获取token
  getUserToken() {
    return this.getUserInfo()?.[this.keyToken] || "";
  }
  //局部更新用户信息（全体换请用saveUserInfo）
  updateUserInfo(newUserInfo) {
    const userInfo = this.getUserInfo();
    if (userInfo) {
      this.saveUserInfo({
        ...userInfo,
        ...newUserInfo
      });
    }
  }
  //获取url参数
  getUrlParams(searchUrl = window.location.hash.split("?")[1], name) {
    let search = searchUrl && searchUrl.replace(/\?/, "").split("&");
    let data = {};
    search &&
      search.forEach((item, index) => {
        let items = item.split("="),
          key = items[0],
          val = items[1];
        data[key] = decodeURI(val);
      });
    return name ? data[name] : data;
  }
  //清除用户信息
  clearLoginData() {
    this.userInfo = null;
    localStorage.removeItem(this.keyUserInfo);
  }
  goBackLogin() {
    let url = "/";
    const { type } = this.getSourceInfo();
    this.clearLoginData();
    if (type != 1) {
      url = getBasicUrls().accountCenter + "/role";
    }
    window.location.href = url;
  }
  goSsoLogin() {
    this.clearLoginData();
    window.location.href = getBasicUrls().accountCenter;
  }
  goLoginPage() {
    this.clearLoginData();
    window.location.href = "/";
  }
  //路由白名单页面
  checkPageWhiteList(path) {
    const list = ["/", "/main/NoPermission", "/ssologin"];
    if (path && list.includes(path)) {
      return true;
    }
    return false;
  }
}

export default LoginUserHelper.getInstance();
